<template>
  <div>
    <b-form-group :label="$t('field.name')">
      <b-form-input
        v-model="item.name"
        name="name"
        type="text"
        required
        placeholder="Lorem ipsum set dolor"
      />
    </b-form-group>
    <b-form-group :label="$t('field.value')">
      <b-input-group append="%">
        <b-form-input
          v-model="value"
          class="form-control"
          name="value"
          type="number"
          required
          placeholder="23"
          @update="formatDecimal"
        />
      </b-input-group>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    value: null
  }),
  computed: {
    ...mapGetters({
      item: 'form/fields'
    })
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.value = this.item.value
      this.formatPercentage()
    },
    formatDecimal() {
      this.item.value = Math.round(this.value * 1000) / 100000
    },
    formatPercentage() {
      if (this.value) {
        this.value =
          Math.round(this.value * Math.pow(10, 3) * 100) / Math.pow(10, 3)
      }
    }
  }
}
</script>
